import { Box, Button, TextField } from "@mui/material";
import BlogEditing from "./sub-Components/BlogEditing";
import CircularProgress from '@mui/material/CircularProgress';
import { uploadLoadingSpace } from "../assets/styles";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useRef, useState } from "react";

const BlogComponent = ({ setFile, handleBlogUpload, loadingUploadBtn }) => {
    const fileRef = useRef(null);
    const titleRef = useRef(null);
    const [content, setContent] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        const file = fileRef.current.files[0];
        const title = titleRef.current.value;
        if (!file || !title || !content) {
            alert('All fields are mandatory');
            return;
        }
        handleBlogUpload(file, title, content);
    };

    return (
        <Box>
            <Box  >
                {
                    loadingUploadBtn ? <Box style={uploadLoadingSpace}><CircularProgress sx={{ marginRight: "1rem" }} size={24} /> Loading . . .</Box> :
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="off"
                            onSubmit={handleSubmit}
                        >
                            <Box sx={{
                                width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 1,
                            }}>
                                <TextField
                                    id="outlined-basic"
                                    label='Select Image'
                                    variant="outlined"
                                    type='file'
                                    name='file'
                                    inputRef={fileRef}
                                    style={{ width: "30%" }}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(event) => setFile(event.target.files[0])}
                                />
                                <TextField
                                    id="outlined-multiline-title"
                                    label="Write Title"
                                    multiline
                                    rows={1}
                                    inputRef={titleRef}
                                    style={{ width: '70%' }}
                                />
                            </Box>
                            <ReactQuill
                                value={content}
                                onChange={setContent}
                                style={{ height: '200px', marginBottom: '2rem' }}
                            />
                            <Box sx={{ display: "flex", justifyContent: "end" }}>
                                <Button variant="contained" type='submit' sx={{ marginLeft: 1, marginTop: 2 }}>Upload</Button>
                            </Box>
                        </Box>
                }
            </Box>
            <Box p={2} />
            <Box>
                <BlogEditing />
            </Box>
        </Box>
    )
}
export default BlogComponent;